// extracted by mini-css-extract-plugin
module.exports = {"headerAfs":"Public_headerAfs__1GPno","footerAfs":"Public_footerAfs__2vH0A","headerIpc":"Public_headerIpc__1G7Kn","footerIpc":"Public_footerIpc__1DBgC"};